// src/lib/gpLogos.js — GP logos, keyed by mandate_name. Dropped in manually
// from ~/rga/GP-logos (Travis), not derived from any mandate/firm field.
// Shared by PortalMandates (tile view) and MandateHeader (mandate-scoped page
// header).
export const GP_LOGOS = {
  'Brentwood Fund VII': '/gp-logos/brentwood.png',
  'Chain Reaction':     '/gp-logos/chain-reaction.png',
  'JVP CV':             '/gp-logos/jvp.png',
  'JVP Fund 12':        '/gp-logos/jvp.png',
  'Merchant':           '/gp-logos/merchant.png',
  'Robinson':           '/gp-logos/rfg.png',
  'Boom':               '/gp-logos/boom.png',
  'ZT Motors':          '/gp-logos/zt.png',
  'Remilk':             '/gp-logos/remilk.png',
}

// Remilk's wordmark is cream-on-transparent — invisible on the portal's
// light-mode white card background. remilk-light.png is a crop straight out
// of Remilk's exec overview deck (its title slide, navy background baked
// in), used only in light mode. Dark mode keeps GP_LOGOS's transparent
// logo, which reads fine against the dark card.
export const GP_LOGOS_LIGHT_OVERRIDE = {
  'Remilk': '/gp-logos/remilk-light.png',
}

// Internal-CRM-only logos for pipeline mandates that aren't LIVE yet, so they
// never reach the portal. Pulled from each company's own site 2026-10-07 and
// recolored for the CRM's dark cards (dark wordmarks turned white).
// If one of these goes LIVE,
// move it into GP_LOGOS and add a GP_LOGOS_LIGHT_OVERRIDE for portal light
// mode, since the white versions vanish on a white card.
export const CRM_GP_LOGOS = {
  ...GP_LOGOS,
  'Delos':                   '/gp-logos/delos.svg',
  'Healthkois':              '/gp-logos/healthkois.svg',
  'Port City BPO Sri Lanka': '/gp-logos/port-city.png',
  'SpotIt':                  '/gp-logos/spotit.svg',
  'St Dominique':            '/gp-logos/st-dominique.png',
  'True Layer':              '/gp-logos/truelayer.svg',
  'Upway':                   '/gp-logos/upway.png',
}

// CRM light mode: dark-ink versions of the logos recolored white above, plus
// the portal's existing light overrides (Remilk).
export const CRM_GP_LOGOS_LIGHT_OVERRIDE = {
  ...GP_LOGOS_LIGHT_OVERRIDE,
  'Delos':        '/gp-logos/delos-light.svg',
  'Healthkois':   '/gp-logos/healthkois-light.svg',
  'SpotIt':       '/gp-logos/spotit-light.svg',
  'St Dominique': '/gp-logos/st-dominique-light.png',
  'True Layer':   '/gp-logos/truelayer-light.svg',
}
